import { Component, Inject, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-persist-info-modal',
	templateUrl: './persist-info-modal.html'
})

export class PersistInfoModalComponent implements OnInit {
	public form: UntypedFormGroup;
	public selectedCustomer: any;
	@ViewChildren('checkbox') public checkboxes: UntypedFormControl;

	constructor(public dialogRef: MatDialogRef<PersistInfoModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder) {
	}

	ngOnInit(): void {
		this.selectedCustomer = this.data?.selectedCustomer;
		this.form = this._formBuilder.group({
			saveReference1: false,
			saveReference2: false,
			saveServiceType: false,
			saveParcels: false,
			savePieces: false,
			saveWeight: false
		});
	}

	closeModal() {
		const savedFields = [];
		if (this.form.value.saveReference1) {
			savedFields.push('reference1');
		}
		if (this.form.value.saveReference2) {
			savedFields.push('reference2');
		}
		if (this.form.value.saveServiceType) {
			savedFields.push('serviceType');
		}
		if (this.form.value.saveParcels) {
			savedFields.push('saveParcels');
		}
		if (this.form.value.savePieces) {
			savedFields.push('pieces');
		}
		if (this.form.value.saveWeight) {
			savedFields.push('weight');
		}
		this.dialogRef.close(savedFields);
	}
}
